/*jshint esversion: 6 */
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * GSAP ScrollTrigger Component
 * 
 * Initializes GSAP and ScrollTrigger for general scroll-based animations
 * 
 * Usage:
 * - Add data-gsap attribute to elements you want to animate
 * - Configure with data attributes or use the API directly
 * - Block-specific animations should be in their respective block files
 */

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

const GsapScroll = (function($) {

  const _s = {
    container: '[data-gsap]',
    fadeIn: '.has-fade-in',
    verticalStar: '.is-style-vertical-star'
  };

  const _init = function() {
    _setupScrollTrigger();
    _setupFadeIn();
    _setupVerticalStar();
    _bindEvents();
  };

  // ===================
  // Setup ScrollTrigger defaults
  const _setupScrollTrigger = function() {
    ScrollTrigger.defaults({
      toggleActions: 'play none none none',
      start: 'top 80%',
      end: 'bottom 20%',
    });
  };

  // ===================
  // Setup Fade In Animation
  const _setupFadeIn = function() {
    const fadeElements = document.querySelectorAll(_s.fadeIn);
    
    if (fadeElements.length === 0) {
      return;
    }

    fadeElements.forEach((element) => {
      // Get custom settings from data attributes or use defaults
      const start = element.dataset.fadeStart || 'top 100%';
      const end = element.dataset.fadeEnd || 'top 50%';
      const scrub = element.dataset.fadeScrub || 1;
      
      gsap.fromTo(element, 
        {
          opacity: 0
        },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: element,
            start: start,
            end: end,
            scrub: parseFloat(scrub),
          }
        }
      );
    });
  };

  // ===================
  // Setup Vertical Star Animation
  const _setupVerticalStar = function() {
    const starElements = document.querySelectorAll(_s.verticalStar);
    
    if (starElements.length === 0) {
      return;
    }

    starElements.forEach((element) => {
      // Get the element height to calculate the star travel distance
      const elementHeight = element.offsetHeight;
      const starStartOffset = elementHeight - 74; // Start from bottom minus the offset
      
      
      // Animate star position, line height, and opacity
      gsap.fromTo(element, 
        {
          '--star-offset': starStartOffset,
          '--line-height': 0,
          '--star-opacity': 0,
          '--line-opacity': 0
        },
        {
          '--star-offset': 0,
          '--line-height': 100,
          '--star-opacity': 1,
          '--line-opacity': 1,
          duration: 1.2,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: element,
            start: 'top bottom',
            end: 'bottom bottom',
            toggleActions: 'play none none none',
            once: true
          }
        }
      );
    });
  };

  // ===================
  // Bind Events
  const _bindEvents = function() {
    // Refresh ScrollTrigger on window resize
    window.addEventListener('resize', () => {
      ScrollTrigger.refresh();
    });
  };

  return {
    container: _s.container,
    init: _init,
    gsap: gsap,
    ScrollTrigger: ScrollTrigger
  };

})(jQuery);

export default GsapScroll;
